import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FullCalendarModule } from '@fullcalendar/angular';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { LaaSSharedModule } from 'src/app/shared/laas-shared.module';
import { EnvironmentMonitorComponent } from './pages/environment-monitoring/environment-monitor.component';
import { StockInfoSearchComponent } from './pages/stock-info-search/stock-info-search.component';
import { StockMaintenanceImportComponent } from './pages/stock-maintenance/stock-maintenance-import/stock-maintenance-import.component';
import { StockMaintenanceComponent } from './pages/stock-maintenance/stock-maintenance.component';
import { StockSkuSearchComponent } from './pages/stock-sku-search/stock-sku-search.component';
import { ExpiredControlComponent } from '../transport-operation/pages/expired-control/expired-control.component';
import { StockRoutingModule } from './stock-routing.module';

@NgModule({
  declarations: [
    StockMaintenanceComponent,
    StockMaintenanceImportComponent,
    StockSkuSearchComponent,
    EnvironmentMonitorComponent,
    StockInfoSearchComponent,
    ExpiredControlComponent,
  ],
  imports: [
    CommonModule,
    StockRoutingModule,
    LaaSSharedModule,
    CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory }),
    FullCalendarModule
  ]
})
export class StockModule {}
